import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

class ConfirmReservation extends Component {
  render() {
    const {
      showBrowserModal,
      closeModal,
      confirm_data,
      onSubmit,
      isButtonDisable,
    } = this.props;
    return (
      <Modal lg={"medium"} show={showBrowserModal} onHide={closeModal}>
        <Modal.Header className="no-border">
          <h4 className="m-0 font-weight-bold">{confirm_data.title}</h4>
          <Button
            title={confirm_data.title}
            type="button"
            onClick={closeModal}
            className="close-btn"
            data-dismiss="modal"
          >
            <i className="nc-icon nc-simple-remove"></i>
          </Button>
        </Modal.Header>

        <Modal.Body className="modal-data-body">
          <p>
            For {confirm_data.firstName} {confirm_data.lastName}, Plate number{" "}
            {confirm_data.plateNumber}
          </p>
          <p>Credits used: {confirm_data.usedCredits}</p>
          <p>Starting : {confirm_data.startTime}</p>
          <p>Ending : {confirm_data.endTime}</p>
          {/* <p className="theme-color"></p> */}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={closeModal} type="button" className="btn btn-danger">
            Cancel
          </Button>
          <Button
            style={{ minWidth: "93px" }}
            onClick={onSubmit}
            type="button"
            disabled={isButtonDisable}
            className="btn btn-fill btn-info"
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ConfirmReservation;
